import React from 'react';
import PropTypes from 'prop-types';
import {
  FormattedDate,
} from 'react-intl';
import {
  date,
} from 'config';
import storage from 'utils/data/storage';
import './index.scss';

const propTypes = { openAbout: PropTypes.func };

const defaultProps = { openAbout: () => {} };

const Title = () => {
  const start = <FormattedDate value={new Date(storage.metadata.start)} timeZone="America/New_York" />;

  return (
    <span className="title">
      {storage.metadata.name}
      {date.enabled ? (
        <> - {start}</>
      ) : null}
    </span>
  );
};

Title.propTypes = propTypes;
Title.defaultProps = defaultProps;

export default Title;
